import { Avatar } from "@bigbinary/neeto-atoms";
import { truncate } from "neetocist";

const ProfileHeader = ({ profileInfo }) => {
  const { name, email, imageUrl } = profileInfo;

  return (
    <span
      className="flex w-full min-w-0 items-center gap-2 text-start"
      data-testid="floating-action-menu-profile-header"
    >
      <Avatar
        className="size-8 shrink-0"
        data-testid="floating-action-menu-header-profile-icon"
        user={{ name, imageUrl }}
      />
      <span className="flex min-w-0 flex-grow flex-col gap-1">
        <span
          className="text-sm leading-tight font-semibold"
          data-testid="floating-action-menu-header-user-name"
          title={name}
        >
          {truncate(name, 18)}
        </span>
        {email && (
          <span
            className="text-muted-foreground w-full truncate text-xs leading-tight"
            data-testid="floating-action-menu-header-user-email"
          >
            {email}
          </span>
        )}
      </span>
    </span>
  );
};

export default ProfileHeader;
